import { createActionGroup, props } from '@ngrx/store';

export const StorageActions = createActionGroup({
  source: 'Storage',
  events: {
    /**
     * Dispatched exactly once at startup, after every registered slice has been read.
     * `slices` holds the raw payloads keyed by slice name; a slice that was never written
     * is simply absent. The hydration meta-reducer reshapes them into the state.
     *
     * Doubles as the signal that writing back to storage may begin.
     */
    Hydrated: props<{ slices: Record<string, unknown> }>(),
  },
});
